module.exports = __webpack_public_path__ + "static/media/pine.482bfc45.m4a";